import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { getModalStyles, getPageContainerStyles, getSearchFormStyles } from '../utils/styleUtils';

const TEXT = {
  title: {
    ko: '관리자 페이지',
    en: 'Admin Page',
    fr: 'Page Admin'
  },
  editProfile: {
    ko: '관리자정보수정',
    en: 'Edit Admin Profile',
    fr: 'Modifier le profil admin'
  },
  calendarManage: {
    ko: '캘린더관리',
    en: 'Calendar Management',
    fr: 'Gestion du calendrier'
  },
  staffArtists: {
    ko: '레지던트아티스트관리',
    en: 'Staff Artists Management',
    fr: 'Gestion des artistes résidents'
  },
  guestArtists: {
    ko: '게스트아티스트관리',
    en: 'Guest Artists Management',
    fr: 'Gestion des artistes invités'
  },
  users: {
    ko: '회원들정보관리',
    en: 'Users Management',
    fr: 'Gestion des utilisateurs'
  },
  styleGuide: {
    ko: '스타일 가이드',
    en: 'Style Guide',
    fr: 'Guide de style'
  },
  userRegistration: {
    ko: '유저등록',
    en: 'User Registration',
    fr: 'Inscription utilisateur'
  },
  guestRegistration: {
    ko: '게스트등록',
    en: 'Guest Registration',
    fr: 'Inscription invité'
  },
  artistPage: {
    ko: 'SNS 테스트',
    en: 'SNS Test',
    fr: 'Test SNS'
  }
};

function AdminPage() {
  const navigate = useNavigate();
  const { userInfo } = useContext(UserContext);
  const lang = userInfo?.preferred_language || 'ko';

  // 공통 스타일 가져오기
  const modalStyles = getModalStyles();
  const pageContainerStyles = getPageContainerStyles();
  const searchStyles = getSearchFormStyles();

  useEffect(() => {
    // 필요시 추가 effect
  }, [navigate]);

  return (
    <div className={pageContainerStyles.pageContainer}>
      {/* 페이지 타이틀 */}
      <h1 className={pageContainerStyles.pageTitle}>
        {TEXT.title[lang]}
      </h1>

      {/* 관리 메뉴 섹션 */}
      <div style={{
        border: '1px solid #000',
        background: '#fff',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h2 style={{ margin: '0 0 15px 0', fontSize: '18px', fontWeight: '500' }}>
          관리 메뉴
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/edit-profile')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.editProfile[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/AdminCalendarPage')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.calendarManage[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/staff-artists')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.staffArtists[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/guest-artists')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.guestArtists[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/users')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.users[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/style-guide')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.styleGuide[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/register')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.userRegistration[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/admin/guest-registration')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.guestRegistration[lang]}
            </button>
          </div>

          <div className={searchStyles.searchForm} style={{ marginBottom: '0' }}>
            <button
              onClick={() => navigate('/sns/home')}
              style={{ width: '100%', justifyContent: 'flex-start', padding: '12px 16px' }}
            >
              {TEXT.artistPage[lang]}
            </button>
          </div>
        </div>
      </div>

      {/* 현재 관리자 정보 */}
      <div className={modalStyles.modalContent} style={{
        border: '1px solid #000',
        background: '#fff',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: '500' }}>
          현재 관리자 정보
        </h3>
        <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
          <div>사용자: {userInfo?.user_name || 'Unknown'}</div>
          <div>레벨: {userInfo?.level || 'Unknown'}</div>
          <div>언어: {lang === 'ko' ? '한국어' : lang === 'en' ? 'English' : 'Français'}</div>
        </div>
      </div>

      {/* 하단 여백 */}
      <div style={{ height: '50px' }}></div>
    </div>
  );
}

export default AdminPage;